import { BATTERY_ACTIVITY_TYPES as ACTIVITY_TYPES } from "./constants";

export const MOCK_ACTIVITY_GROUPS = [
  {
    date: "TODAY",
    activities: [
      {
        id: "act-1",
        time: "12:12 pm",
        type: ACTIVITY_TYPES.KEPT_FOR_CHARGING,
        hub: "Magena Agr-E-Hub",
        batteryCharge: 45,
      },
      {
        id: "act-2",
        time: "11:45 am",
        type: ACTIVITY_TYPES.CHECKED_IN_SOS,
        agent: "Steven Oyugi",
        driver: "Moses Sambaza",
      },
      {
        id: "act-3",
        time: "10:41 am",
        type: ACTIVITY_TYPES.WITHDRAWN_LOCKER,
        locker: "A4",
        hub: "Magena Agr-E-Hub",
        agent: "Steven Oyugi",
        trip: "Trip 2234",
      },
      {
        id: "act-4",
        time: "10:11 am",
        type: ACTIVITY_TYPES.ASSIGNED_TRIP,
        trip: "Trip 2234",
        driver: "Moses Sambaza",
      },
      {
        id: "act-5",
        time: "9:10 am",
        type: ACTIVITY_TYPES.DEPOSITED_LOCKER,
        locker: "A4",
        hub: "Magena Agr-E-Hub",
        agent: "Steven Oyugi",
      },
      {
        id: "act-6",
        time: "8:23 am",
        type: ACTIVITY_TYPES.FULLY_CHARGED,
        hub: "Magena Agr-E-Hub",
        batteryCharge: 100,
      },
      {
        id: "act-7",
        time: "7:22 am",
        type: ACTIVITY_TYPES.KEPT_FOR_CHARGING,
        hub: "Magena Agr-E-Hub",
        batteryCharge: 24,
      },
      {
        id: "act-8",
        time: "7:12 am",
        type: ACTIVITY_TYPES.WITHDRAWN_LOCKER,
        locker: "D1",
        hub: "Magena Agr-E-Hub",
        agent: "Steven Oyugi",
      },
    ],
  },
  {
    date: "YESTERDAY",
    activities: [
      {
        id: "act-9",
        time: "4:50 pm",
        type: ACTIVITY_TYPES.CHECKED_IN,
        hub: "Magena Agr-E-Hub",
        driver: "Moses Sambaza",
        trip: "Trip 5615",
      },
      {
        id: "act-10",
        time: "4:50 pm",
        type: ACTIVITY_TYPES.CHECKED_OUT,
        hub: "Sengera Agr-E-Hub",
        agent: "Steven Oyugi",
        trip: "Trip 6262",
      },
      {
        id: "act-11",
        time: "4:50 pm",
        type: ACTIVITY_TYPES.WITHDRAWN_LOCKER,
        locker: "D1",
        hub: "Sengera Agr-E-Hub",
        agent: "Steven Oyugi",
      },
      {
        id: "act-12",
        time: "6:04 am",
        type: ACTIVITY_TYPES.ASSIGNED_SWAP,
        hub: "Magena Agr-E-Hub",
        trip: "Trip 6262",
      },
      {
        id: "act-13",
        time: "6:44 pm",
        type: ACTIVITY_TYPES.DEPOSITED_LOCKER,
        locker: "D1",
        hub: "Magena Agr-E-Hub",
      },
      {
        id: "act-14",
        time: "10:44 am",
        type: ACTIVITY_TYPES.WITHDRAWN_LOCKER,
        locker: "A4",
        hub: "Magena Agr-E-Hub",
        agent: "Steven Oyugi",
        isRental: true,
        trip: "Trip 5662",
      },
      {
        id: "act-15",
        time: "9:10 am",
        type: ACTIVITY_TYPES.ASSIGNED_RENTAL,
        trip: "Trip 5662",
        driver: "Moses Sambaza",
      },
      {
        id: "act-16",
        time: "11:45 am",
        type: ACTIVITY_TYPES.ASSIGNED_SOS,
        driver: "Moses Sambaza",
      },
      {
        id: "act-17",
        time: "8:20 am",
        type: ACTIVITY_TYPES.DEPOSITED_LOCKER,
        locker: "B8",
        hub: "Magena Agr-E-Hub",
        agent: "Steven Oyugi",
      },
      {
        id: "act-18",
        time: "8:14 am",
        type: ACTIVITY_TYPES.FULLY_CHARGED,
        hub: "Magena Agr-E-Hub",
        batteryCharge: 100,
      },
      {
        id: "act-19",
        time: "7:02 am",
        type: ACTIVITY_TYPES.KEPT_FOR_CHARGING,
        hub: "Magena Agr-E-Hub",
        batteryCharge: 17,
      },
      {
        id: "act-20",
        time: "6:15 am",
        type: ACTIVITY_TYPES.WITHDRAWN_LOCKER,
        locker: "A5",
        hub: "Sengera Agr-E-Hub",
        agent: "Cleopatra Magada",
      },
      {
        id: "act-21",
        time: "6:04 am",
        type: ACTIVITY_TYPES.ASSIGNED_TRANSFER,
        routeFrom: "Sengera Agr-E-Hub",
        routeTo: "Magena Agr-E-Hub",
      },
    ],
  },
  {
    date: "JAN 29, 2026",
    activities: [
      {
        id: "act-22",
        time: "4:50 pm",
        type: ACTIVITY_TYPES.CHECKED_IN,
        hub: "Magena Agr-E-Hub",
        driver: "Moses Sambaza",
        trip: "Trip 5615",
      },
      {
        id: "act-23",
        time: "4:50 pm",
        type: ACTIVITY_TYPES.CHECKED_OUT,
        hub: "Sengera Agr-E-Hub",
        agent: "Steven Oyugi",
      },
      {
        id: "act-24",
        time: "4:50 pm",
        type: ACTIVITY_TYPES.WITHDRAWN_LOCKER,
        locker: "D1",
        hub: "Sengera Agr-E-Hub",
        agent: "Steven Oyugi",
      },
      {
        id: "act-25",
        time: "4:23 pm",
        type: ACTIVITY_TYPES.ASSIGNED_TRANSFER,
        routeFrom: "Magena Agr-E-Hub",
        routeTo: "Sengera Agr-E-Hub",
        trip: "Trip 6816",
      },
      {
        id: "act-26",
        time: "5:25 pm",
        type: ACTIVITY_TYPES.DEPOSITED_LOCKER,
        locker: "A5",
        hub: "Sengera Agr-E-Hub",
        agent: "Cleopatra Magada",
      },
      {
        id: "act-27",
        time: "4:50 pm",
        type: ACTIVITY_TYPES.CHECKED_IN,
        hub: "Magena Agr-E-Hub",
        agent: "Steven Oyugi",
      },
      {
        id: "act-28",
        time: "4:50 pm",
        type: ACTIVITY_TYPES.CHECKED_OUT,
        hub: "Magena Agr-E-Hub",
        driver: "Moses Sambaza",
        trip: "Trip 6816",
      },
      {
        id: "act-29",
        time: "6:04 am",
        type: ACTIVITY_TYPES.ASSIGNED_SWAP,
        hub: "Magena Agr-E-Hub",
        isRental: true,
        trip: "Trip 6815",
      },
      {
        id: "act-30",
        time: "5:10 pm",
        type: ACTIVITY_TYPES.ASSOCIATED_RENTAL,
        trip: "Trip 6816",
      },
      {
        id: "act-31",
        time: "4:50 pm",
        type: ACTIVITY_TYPES.WITHDRAWN_LOCKER,
        locker: "D6",
        hub: "Sengera Agr-E-Hub",
        agent: "Cleopatra Magada",
      },
      {
        id: "act-32",
        time: "5:30 pm",
        type: ACTIVITY_TYPES.ASSIGNED_RENTAL,
        trip: "Trip 6816",
        driver: "Cleo Toporesu",
      },
      {
        id: "act-33",
        time: "5:25 pm",
        type: ACTIVITY_TYPES.DEPOSITED_LOCKER,
        locker: "D6",
        hub: "Sengera Agr-E-Hub",
        agent: "Cleopatra Magada",
      },
      {
        id: "act-34",
        time: "4:50 pm",
        type: ACTIVITY_TYPES.CHECKED_IN,
        hub: "Sengera Agr-E-Hub",
        agent: "Cleopatra Magada",
      },
      {
        id: "act-35",
        time: "4:50 pm",
        type: ACTIVITY_TYPES.CHECKED_OUT,
        hub: "Magena Agr-E-Hub",
        agent: "Steven Oyugi",
      },
      {
        id: "act-36",
        time: "4:50 pm",
        type: ACTIVITY_TYPES.WITHDRAWN_LOCKER,
        locker: "D1",
        hub: "Magena Agr-E-Hub",
        agent: "Steven Oyugi",
      },
      {
        id: "act-37",
        time: "4:23 pm",
        type: ACTIVITY_TYPES.ASSIGNED_TRANSFER,
        routeFrom: "Magena Agr-E-Hub",
        routeTo: "Sengera Agr-E-Hub",
      },
      {
        id: "act-38",
        time: "3:13 pm",
        type: ACTIVITY_TYPES.DEPOSITED_LOCKER,
        locker: "D1",
        hub: "Magena Agr-E-Hub",
        agent: "Steven Oyugi",
      },
      {
        id: "act-39",
        time: "12:11 pm",
        type: ACTIVITY_TYPES.ASSOCIATED_SESSION,
        session: "Session 841",
      },
      {
        id: "act-40",
        time: "11:41 am",
        type: ACTIVITY_TYPES.WITHDRAWN_LOCKER,
        locker: "A4",
        hub: "Magena Agr-E-Hub",
      },
      {
        id: "act-41",
        time: "10:11 am",
        type: ACTIVITY_TYPES.ASSIGNED_SESSION,
        session: "Session 841",
        driver: "Moses Sambaza",
      },
    ],
  },
  {
    date: "JAN 28, 2026",
    activities: [
      {
        id: "act-42",
        time: "6:05 pm",
        type: ACTIVITY_TYPES.DEPOSITED_LOCKER,
        locker: "D6",
        hub: "Magena Agr-E-Hub",
        agent: "Steven Oyugi",
      },
      {
        id: "act-43",
        time: "5:50 pm",
        type: ACTIVITY_TYPES.SERVICE_COMPLETED,
      },
      {
        id: "act-44",
        time: "4:23 pm",
        type: ACTIVITY_TYPES.ADDED_TO_SERVICE,
        hub: "Sengera Agr-E-Hub",
        severity: "Serious",
      },
      {
        id: "act-45",
        time: "4:10 pm",
        type: ACTIVITY_TYPES.WITHDRAWN_LOCKER,
        locker: "A4",
        hub: "Magena Agr-E-Hub",
        agent: "Cleopatra Magada",
      },
      {
        id: "act-46",
        time: "3:13 pm",
        type: ACTIVITY_TYPES.DEPOSITED_LOCKER,
        locker: "D1",
        hub: "Magena Agr-E-Hub",
        agent: "Cleopatra Magada",
      },
      {
        id: "act-47",
        time: "12:11 pm",
        type: ACTIVITY_TYPES.ASSOCIATED_SESSION,
        session: "Session 841",
      },
      {
        id: "act-48",
        time: "11:41 am",
        type: ACTIVITY_TYPES.WITHDRAWN_LOCKER,
        locker: "A4",
        hub: "Magena Agr-E-Hub",
        agent: "Cleopatra Magada",
      },
      {
        id: "act-49",
        time: "10:11 am",
        type: ACTIVITY_TYPES.ASSIGNED_SESSION,
        session: "Session 841",
        driver: "Moses Sambaza",
      },
      {
        id: "act-50",
        time: "9:34 am",
        type: ACTIVITY_TYPES.DEPOSITED_LOCKER,
        locker: "B8",
        hub: "Magena Agr-E-Hub",
        agent: "Cleopatra Magada",
      },
    ],
  },
];
